import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import userPic from "../assets/images/user-pic.png";
import comingSoonPic from "../assets/images/coming-soon-pic.jpg";
import { homePageMeta } from "../components/ui/MetaHead";
import TopPunishments from "../components/homePage/TopPunishments";
import FavouritePunishments from "../components/homePage/FavoritePunishments";
import FeaturedProducts from "../components/homePage/FeaturedProducts";
import LatestBlogs from "../components/homePage/LatestBlogs";
import React, { useEffect, useState } from "react";
// import CountDownTimer from "../components/homePage/CountDownTimer";
import { Parallax } from "react-scroll-parallax";
import LeagueRegistrationSlider from "../components/ui/LeagueRegistrationSlider";
import AdUnit from "../components/utils/adUnit";
import { FeedType } from "../types/socialFeed";
import { getSocialFeeds } from "../services/firebase";
import MetaHead from "../components/ui/MetaHead";
import { Link, useNavigate } from "react-router-dom";
import NewsletterSignup from "../components/NewsletterSignup/NewsletterSignup";
import { useAuth } from "../contexts/AuthContext";
import { FLLogo } from "../components/CustomIcons";

const HomePage: React.FC = () => {
  const user = useAuth().user;
  const items = ["DRAFTING", "WINNING", "WATCHING FRIENDS SUFFER"];
  const [itemIndex, setItemIndex] = useState(0);
  const [isRegistrationOpen, setIsRegistrationOpen] = useState(false);
  const [socialFeeds, setSocialFeeds] = useState<FeedType[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (itemIndex < items.length) {
      const timer = setTimeout(() => {
        setItemIndex(itemIndex + 1);
      }, 1000); // Delay between fades (adjust as needed)

      return () => clearTimeout(timer);
    }
  }, [itemIndex, items.length]);

  useEffect(() => {
    // Fetching socialFeeds and storing in desc order to show latest created at top of grid
    (async () => {
      try {
        const feedList = await getSocialFeeds();
        const slicedList = feedList.splice(0, 8); // show only latest 4 feeds
        setSocialFeeds(slicedList);
      } catch (err) {
        console.error("Failed to fetch socialFeeds:", err);
      }
    })();
  }, []);

  const handleSubmit = (path: string) => {
    switch (path) {
      case "submit-punishment":
        // if (user) {
        //   navigate("/dashboard");
        // } else {
        //   navigate("/home");
        // }
        window.open("https://h4hcbpgn1q9.typeform.com/to/E21Gfvu6", "_blank");
        break;
      case "punishment-ideas":
        navigate("/punishments");
        break;
      default:
        break;
    }
  };

  return (
    <main className="pageOuterWrapper">
      <Navbar />
      <MetaHead
        title={""}
        description={homePageMeta.description}
        keywords={homePageMeta.keywords}
      ></MetaHead>
      <div className="homeTopWrap">
        <div className="leaderboardAdBlk">
          <AdUnit
            slot="2591317351"
            format="horizontal"
            client="ca-pub-2646617990321066"
            style={{ display: "block", width: "100%", maxHeight: "90px" }}
          />
        </div>
        <div className="homeBannerWrap">
          <div className="homeBannerLeftCont">
            <h2>WATCH YOUR FRIENDS SUFFER</h2>
            <div className="bannerSubTxt">
              <span>We celebrate the real heroes — the losers.</span>
              <span>
                Discover punishments, challenges, and viral loser stories.
              </span>
            </div>
            <div className="btnWrapInline">
              <button
                className="btnStyle btnHighlighted"
                onClick={() => handleSubmit("submit-punishment")}
              >
                Submit Punishment
              </button>
              <button
                className="btnStyle btnOutlined"
                onClick={() => handleSubmit("punishment-ideas")}
              >
                Punishment ideas
              </button>
            </div>
          </div>
          <div className="imgVideoBlk">
            <video autoPlay muted preload="auto" loop>
              <source src="/fantasy_loser.webm" type="video/webm" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
        <div className="marqueeDark">
          <div className="marqueeBand">
            <div className="marqueeTrack">
              {[...Array(6)].map((_, i) => (
                <React.Fragment key={i}>
                  <span>LAST PLACE LIVES FOREVER</span>
                  <FLLogo />
                  <span>THE LEAGUES THAT PUNISH, PROSPER</span>
                  <FLLogo />
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
        <div className="marquee">
          <div className="marqueeBand">
            <div className="marqueeTrack">
              {[...Array(6)].map((_, i) => (
                <React.Fragment key={i}>
                  <span>LAST PLACE LIVES FOREVER</span>
                  <FLLogo />
                  <span>THE LEAGUES THAT PUNISH, PROSPER</span>
                  <FLLogo />
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="homeContentWrap">
        <FavouritePunishments />
        <TopPunishments />
        <LatestBlogs />
        <section className="emailSubscriptionBlk">
          <div className="wrapper">
            <NewsletterSignup />
          </div>
        </section>
        <section className="billboardAdBlk">
          <div className="wrapper">
            <AdUnit
              slot="6147418987"
              format="auto"
              client="ca-pub-2646617990321066"
              style={{ display: "block", width: "100%", height: "250px" }}
            />
          </div>
        </section>
        <FeaturedProducts />
        {socialFeeds.length > 0 && (
          <section className="socialBlk">
            <div className="wrapper">
              <div className="sectionHeading">
                <strong>social feed</strong>
                <div className="subTxt">
                  Follow us on Instagram as the chaos continues...
                </div>
              </div>
              <ul className="socialFeed">
                {socialFeeds.map((feed) => (
                  <li key={feed.id}>
                    <div className="socialFeedImg">
                      <a href={feed.url} target="_blank">
                        <img src={feed.image?.toString()} alt={feed.title} />
                      </a>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </section>
        )}
        <LeagueRegistrationSlider
          isOpen={isRegistrationOpen}
          onClose={() => setIsRegistrationOpen(false)}
        />
      </div>
      <Footer />
    </main>
  );
};

export default HomePage;
